import { Box } from '@montugroup/design-system';
import { styled } from '@mui/material';

export const FAQContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#EBEAEE', // TODO: Update color once design-system is imported - Neutral Grey
  flexGrow: 1,
  padding: theme.spacing(0, 2),
  paddingBottom: theme.spacing(30),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(0),
  },
}));

export const ContentWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(4, 3),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(6, 16, 20, 16),
  },
}));
